
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./schema-renderer.cjs.production.min.js')
} else {
  module.exports = require('./schema-renderer.cjs.development.js')
}
